function getViewportSize(): { width: number; height: number } {
	return {
		width: document.documentElement.clientWidth,
		height: document.documentElement.clientHeight
	};
}

function getOverlayBounds(overlayEl: HTMLElement): { width: number; height: number } {
	const rect: DOMRect = overlayEl.getBoundingClientRect();
	const contentEl: HTMLElement = (overlayEl.firstElementChild as HTMLElement) ?? overlayEl;
	const contentRect: DOMRect = contentEl.getBoundingClientRect();

	return {
		width: Math.ceil(Math.max(overlayEl.offsetWidth, rect.width, contentEl.offsetWidth, contentRect.width)),
		height: Math.ceil(Math.max(overlayEl.offsetHeight, rect.height, contentEl.offsetHeight, contentRect.height))
	};
}

export function clampOverlayPosition(
	left: number,
	top: number,
	overlayEl: HTMLElement
): { left: number; top: number } {
	const viewport = getViewportSize();
	const { width, height } = getOverlayBounds(overlayEl);

	return {
		left: Math.min(Math.max(left, 0), Math.max(0, viewport.width - width)),
		top: Math.min(Math.max(top, 0), Math.max(0, viewport.height - height))
	};
}

export function clampOverlayToViewport(overlayEl: HTMLElement): void {
	if (!overlayEl?.isConnected || overlayEl.classList.contains('is-pinned')) return;

	const viewport = getViewportSize();
	const rect: DOMRect = overlayEl.getBoundingClientRect();
	let { width, height } = getOverlayBounds(overlayEl);

	if (width > viewport.width) {
		overlayEl.style.width = `${viewport.width}px`;
		width = viewport.width;
	}

	if (height > viewport.height) {
		overlayEl.style.height = `${viewport.height}px`;
		height = viewport.height;
	}

	const position = clampOverlayPosition(rect.left, rect.top, overlayEl);

	overlayEl.style.position = 'fixed';
	overlayEl.style.left = `${position.left}px`;
	overlayEl.style.top = `${position.top}px`;
	overlayEl.style.right = 'auto';
	overlayEl.style.bottom = 'auto';
}

export function clampOverlaySizeToViewport(overlayEl: HTMLElement): void {
	if (!overlayEl?.isConnected || overlayEl.classList.contains('is-pinned')) return;

	const viewport = getViewportSize();
	const rect: DOMRect = overlayEl.getBoundingClientRect();
	const maxWidth: number = Math.max(0, viewport.width - rect.left);
	const maxHeight: number = Math.max(0, viewport.height - rect.top);

	if (overlayEl.offsetWidth > maxWidth) {
		overlayEl.style.width = `${maxWidth}px`;
	}

	if (overlayEl.offsetHeight > maxHeight) {
		overlayEl.style.height = `${maxHeight}px`;
	}

	clampOverlayToViewport(overlayEl);
}
